import React, { useState } from "react";

const apiUrl = process.env.REACT_APP_API_URL;

export default function ConnectAmazonButton({ className = "" }) {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  async function handleClick() {
    setErr("");
    setLoading(true);
    try {
      const res = await fetch(`${apiUrl}/auth/amazon/consent-url`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || `HTTP ${res.status}`);
      }
      const { url } = await res.json();
      if (!url) throw new Error("Consent URL missing");
      // Redirect to Amazon consent url
      window.location.assign(url);
    } catch (e) {
      setErr(e?.message || "Failed to open Amazon consent");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: 24,
      }}
    >
      <div style={{ width: "100%", maxWidth: 440 }}>
        <div className={className} style={{ maxWidth: 420, width: "100%" }}>
          <button
            type="button"
            onClick={handleClick}
            disabled={loading}
            aria-busy={loading ? "true" : "false"}
            style={{
              width: "100%",
              padding: "20px 20px",
              fontSize: 20,
              fontWeight: 700,
              borderRadius: 10,
              border: "1px solid #222",
              background: loading ? "#ddd" : "#fff",
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? "Opening Amazon consent…" : "Connect Amazon"}
          </button>
          <p style={{ fontSize: 16, color: "#666", marginTop: 8 }}>
            You’ll be redirected to Amazon to grant access. After consenting,
            you’ll return here automatically.
          </p>
          {err && (
            <div role="alert" style={{ color: "crimson", marginTop: 8 }}>
              {err}
            </div>
          )}
        </div>{" "}
      </div>
    </div>
  );
}
